import React from "react";
import {
  LineChart,
  Line,
  ReferenceLine,
  XAxis,
  YAxis,
  CartesianGrid,
  Label,
  ResponsiveContainer,
} from "recharts";
import { CalendarWeek } from "shared/utils";

const PointLabel = ({ x, y, stroke, value }) => (
  <text
    x={x}
    y={y}
    dx={8}
    dy={-4}
    fill={stroke}
    fontSize={14}
    textAnchor="middle"
  >
    {Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(value)}
  </text>
);

const AxisTick = ({ x, y, payload }) => {
  const dateFormatter = new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "short",
  });
  const date = new Date(payload.value);

  return (
    <text x={x} y={y} dy={16} fill="#666" fontSize={10} textAnchor="middle">
      {`${dateFormatter.format(date)} (KW ${CalendarWeek(date)})`}
    </text>
  );
};

const LineChartWithReferenceLine = ({
  chartTitle,
  chartData,
  referenceLineValue,
}) => (
  <ResponsiveContainer aspect={4.0} minHeight={1}>
    <LineChart
      data={chartData}
      margin={{
        top: 15,
        right: 30,
        left: 0,
        bottom: 0,
      }}
    >
      <XAxis
        dataKey="date"
        interval="preserveStartEnd"
        height={80}
        tick={<AxisTick />}
      />
      <YAxis fontSize={10}>
        <Label angle={270} fontSize={12} dx={-15}>
          {chartTitle}
        </Label>
      </YAxis>
      <CartesianGrid strokeDasharray="3 3" />
      <Line
        type="monotone"
        dataKey="value"
        stroke="#1b66b3"
        label={<PointLabel />}
      />
      <ReferenceLine
        y={referenceLineValue}
        stroke="#000"
        strokeDasharray="3 3"
      />
    </LineChart>
  </ResponsiveContainer>
);

export default LineChartWithReferenceLine;
